import {action, computed, makeObservable, observable} from "mobx";

export default class Feature {

    constructor(application) {
        this._application = application;
        this._loaded = false;

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
        })
    }

    finishLoading() {
        this._loaded = true;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }
}
